import type { ProjectWithPermission } from '../api';

interface ProjectCardProps {
  project: ProjectWithPermission;
  onClick: () => void;
  /** External-UI handoff in flight for this project: show a spinner and block
   *  re-clicks (the one-time-code mint is an async call before navigation). */
  busy?: boolean;
}

export function ProjectCard({ project, onClick, busy = false }: ProjectCardProps) {
  return (
    <button className="project-card" onClick={onClick} disabled={busy} aria-busy={busy}>
      <div className="project-card-icon">
        {busy ? (
          <div className="project-card-spinner" />
        ) : (
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <rect x="4" y="6" width="24" height="20" rx="3" stroke="currentColor" strokeWidth="2" />
            <path d="M4 12h24" stroke="currentColor" strokeWidth="2" />
            <circle cx="8" cy="9" r="1" fill="currentColor" opacity="0.5" />
            <circle cx="11" cy="9" r="1" fill="currentColor" opacity="0.5" />
          </svg>
        )}
      </div>
      <div className="project-card-content">
        <h3 className="project-card-name">{project.name}</h3>
      </div>
      <span className={`project-card-permission permission-${project.permission}`}>
        {busy ? 'Opening…' : project.permission === 'owner' ? 'Owner' : 'Viewer'}
      </span>
    </button>
  );
}
